import api from './api';

export interface Pagamento {
  id: number;
  numeroParcela: number;
  valorParcela: number;
  dataVencimento: string;
  dataPagamento?: string | null;
  status: 'Pendente' | 'Pago' | 'Atrasado';
  formaPagamento?: string;
  observacao?: string;
  apolice: {
    id: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreatePagamentoDTO {
  numeroParcela: number;
  valorParcela: number;
  dataVencimento: string | null;
  dataPagamento?: string | null;
  status?: 'Pendente' | 'Pago' | 'Atrasado';
  formaPagamento?: string;
  observacao?: string;
  apoliceId: number;
}

export interface GerarParcelasDTO {
  apoliceId: number;
  quantidadeParcelas: number;
  valorTotal: number;
}

export const pagamentoService = {
  listarPorApolice: async (apoliceId: number): Promise<Pagamento[]> => {
    const response = await api.get(`/apolices/${apoliceId}/pagamentos`);
    return response.data;
  },

  criar: async (pagamento: CreatePagamentoDTO): Promise<Pagamento> => {
    const response = await api.post('/pagamentos', pagamento);
    return response.data;
  },

  atualizar: async (id: number, pagamento: Partial<CreatePagamentoDTO>): Promise<Pagamento> => {
    const response = await api.put(`/pagamentos/${id}`, pagamento);
    return response.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/pagamentos/${id}`);
  },

  gerarParcelas: async (dados: GerarParcelasDTO): Promise<Pagamento[]> => {
    const response = await api.post('/pagamentos/gerar-parcelas', dados);
    return response.data;
  }
}; 